module.exports = __webpack_public_path__ + "static/media/145.4e78f193.webp";